import type { ThemeConfig } from 'antd';
import merge from 'lodash/merge';

export const mergeTheme = (base: ThemeConfig, override: ThemeConfig | undefined): ThemeConfig => merge({}, base, override);
